import React from 'react'
import { Navigate, Route, Routes } from "react-router-dom";
import LayoutMain from '../Layout';
import Login from '../pages/Auth/Login';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import Dashboard from '../pages/Dashboard';
import Users from '../pages/UserManagement/Users';
import AddUser from '../pages/UserManagement/Users/AddUser';
import EditUser from '../pages/UserManagement/Users/EditUser';
import UserRoles from '../pages/UserManagement/UserRoles';
import AddRoles from '../pages/UserManagement/UserRoles/AddRoles';
import EditRoles from '../pages/UserManagement/UserRoles/EditRoles';
import UserPermission from '../pages/UserManagement/UserRoles/UserPermission';
import { GetToken } from '../utils';
import Settings from '../pages/Settings';

import AddTicket from '../pages/TicketManagement/addTicket';
import EditTicket from '../pages/TicketManagement/EditTicket';
import Ticket from '../pages/TicketManagement';

import Abdm from '../pages/ABDM'
import AbhaCreated from '../pages/ABDM/AbhaCreated';
import LinkedReport from '../pages/ABDM/LinkedReport';
import PushRequest from '../pages/ABDM/ReportPushRequest';
import ConsentRequest from '../pages/ABDM/ConsentRequest';
import ConsentSent from '../pages/ABDM/ConsentSent';
import ConsentApproved from '../pages/ABDM/ConsentApproved';
import ReportPushed from '../pages/ABDM/ReportPushed';
import ReportRequested from '../pages/ABDM/ReportRequested';
import ReportReceived from '../pages/ABDM/ReportRecieved';
import AskReport from '../pages/ABDM/AskforReport';
import ReportDetail from '../pages/ABDM/AskforReport/ReportDetail';
function RequireAuth({ children }) {
    const token = GetToken();
    return token ? children : <Navigate to="/login" replace />;
}
function AlreadyLogin({ children }) {
    const token = GetToken();
    return token ? <Navigate to="/" replace /> : children;
}

const PageRoutes = () => {
    return (
        <div className='main_wrapper'>
            <Routes>
                <Route path="/forgot-password" element={<AlreadyLogin> <ForgotPassword /></AlreadyLogin>} />
                <Route path="/login" element={<AlreadyLogin><Login /></AlreadyLogin>} />
                <Route element={<RequireAuth> <LayoutMain /></RequireAuth>}>
                    <Route path="/" element={<Abdm />} />
                    <Route path="/dashboard" element={<Dashboard />} />



                    <Route path="/users" element={<Users />} />
                    <Route path="/user/list" element={<Users />} />
                    <Route path="/user/add" element={<AddUser />} />
                    <Route path="/user/edit/:userId" element={<EditUser />} />

                    <Route path="/roles" element={<UserRoles />} />
                    <Route path="/role/list" element={< UserRoles />} />
                    <Route path="/role/add" element={<AddRoles />} />
                    <Route path="/role/edit/:roleId" element={<EditRoles />} />
                    <Route path="/role/user-permission/:roleId" element={<UserPermission />} />
                    <Route path="/settings" element={<Settings />} />


                    <Route path="/ticket-management" element={<Ticket />} />
                    <Route path="/ticket-management/add" element={<AddTicket />} />
                    <Route path="/ticket-management/edit/:Id" element={<EditTicket />} />
                    <Route path="/abdm" element={<Abdm />} />

                    <Route path="abdm/abha-created" element={<AbhaCreated />} />
                    <Route path="abdm/linked-report" element={<LinkedReport />} />
                    <Route path="abdm/report-push-request" element={<PushRequest />} />
                    <Route path="abdm/consent-request" element={<ConsentRequest />} />
                    <Route path="abdm/consent-sent" element={<ConsentSent />} />
                    <Route path="abdm/consent-approved" element={<ConsentApproved />} />
                    <Route path="abdm/report-pushed" element={<ReportPushed/>} />
                    <Route path="abdm/report-requested" element={<ReportRequested/>} />
                    <Route path="abdm/report-received" element={<ReportReceived />} />
                    <Route path="abdm/ask-report" element={<AskReport />} />
                    <Route path="abdm/report-detail" element={<ReportDetail />} />
                  
                </Route>
            </Routes>
        </div>
    )
}

export default PageRoutes